export const configureFullURLForLocalDevelopment = (url?: string): string =>
    url?.replace('https://localhost', 'http://localhost:8084') ?? ''
